import axesPreRender from './axes-prerender';
import axesPostRender from './axes-postrender';


let styles = null;


export function preRender(data, options) {
  styles = writeStyles(options);
  return axesPreRender(data, options, styles);
}

export function postRender(highchart, options) {
  styles = writeStyles(options);
  return axesPostRender(highchart, options, styles);
}

// Writes styles constants used throughout axes processing.
function writeStyles(options) {
  // const isWSJOnline = !options.product === 'wsj' && options.print ? options.styles.get('normal') : 
  // options.styles.get('normal').fontFamily = '"Retina Narrow", sans-serif';
  const isVideoGroup = options.id === 'video' || options.id === 'twitterVideo'
  let normal = options.styles.get('normal');
  if (options.product === 'wsj' && !options.print) {
    if (options.categoriesAreDates || options.type !== 'column') normal.fontFamily = '"Retina Narrow", sans-serif';
    if (isVideoGroup) normal.fontWeight = 400;
    normal.lineHeight = 15;
  }
  const defaultOptions = {
    FONT_SIZE: parseFloat(options.styles.size.normal),
    NORMAL_STYLE: normal,
    LIGHT_STYLE: options.styles.get('normal', {
      fontFamily: options.styles.font.light,
      fontWeight: options.styles.weight.light
    }),
    BOLD_STYLE: options.styles.get('normal', {
      fontFamily: options.styles.font.bold,
      fontWeight: options.styles.weight.bold
    }),
    SHORT_TICK_LENGTH: 4,
    MEDIUM_TICK_LENGTH: 7,
    LONG_TICK_LENGTH: parseFloat(options.styles.size.normal) + 5,
    MARGIN: 3
  };

  if (__MARKETWATCH__) {
    if (options.product === 'marketwatch') {
      return Object.assign({}, defaultOptions, {
        NORMAL_STYLE: options.styles.get('normal', {
          fontFamily: options.styles.font.semibold,
          fontWeight: options.styles.weight.semibold
        })
      });
    }
  }

  if (__WSJ__) {
    if (options.product === 'wsj') {
      const hideTicks = (!options.categoriesAreDates && options.type === 'column')
      return Object.assign({}, defaultOptions, {
        SHORT_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.shortSize,
        MEDIUM_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.mediumSize,
        FONT_SIZE: options.styles.axes.label.fontSize,
        LONG_TICK_LENGTH: hideTicks ? 0 : options.styles.tick.longSize,
        AXES: options.styles.axes
      });
    }
  }

  if (options.product === 'knewz') {
    return Object.assign({}, defaultOptions, {
      NORMAL_STYLE: options.styles.get('normal', {
        fontWeight: 700,
        fontSize: options.styles.axes.label.fontSize,
        lineHeight: options.styles.axes.label.lineHeight
      })
    })
  }

  if (__MANSIONGLOBAL__) {
    if (options.product === 'mansionglobal') {
      return Object.assign({}, defaultOptions, {
        AXES: options.styles.axes
      })
    }
  }

  return defaultOptions;
}



// WEBPACK FOOTER //
// ./src/chart/inner/axes.js